<template>
	<div class="relative z-backdrop">
		<div class="fixed modal-mobile left-0 right-0 z-modal w-full">
			<div class="only-desktop absolute right-1 -top-5">
				<svg width="27" height="24" viewBox="0 0 27 24" fill="none" xmlns="http://www.w3.org/2000/svg">
					<path d="M13.5 0L26.9234 23.25H0.0766058L13.5 0Z" fill="#263042"/>
				</svg>
			</div>
			<div class="overflow-auto relative bg-zt-normal rounded-t-xl shadow-lg !max-h-[calc(100vh_-_126px)]">
				<div class="sticky only-mobile top-0 left-0 right-0 bg-zt-normal z-10">
					<div class="w-full py-4 px-5 only-mobile-flex justify-start items-center">
						<span class="font-semibold text-base">Opcje</span>
						<div class="x-close-modal" @click="closeModal"></div>
					</div>
					<hr class="w-full border-zt-light only-mobile">
				</div>
				<div v-for="(option, index) of options"
				     class="flex flex-col items-center bg-zt-normal rounded-b-xl w-full text-base">
					<div @click="handleOptionClick(option)"
					     :class="{ 'selected' : model.string === option }"
					   class="option w-full p-4 flex relative items-center zt-hover">
						<span class="text-left">{{ getSeasonPhaseString(option) }}</span>
					</div>
					<hr v-if="options.length -1 !== index" class="w-full border-zt-light">
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import football_mixin from "../mixins/football_mixin";
import utils_mixin from "../mixins/utils_mixin";

export default {
	name: 'SeasonPhaseSelectMobile',
	mixins: [football_mixin, utils_mixin],
	emits: ['closeModal', 'changeOption'],
	props: {
		options: {
			type: Array,
			required: true,
		},
		model: {
			type: Object,
			required: false,
			default(rawProps) {
				if (!rawProps.placeholder) {
					return { string: rawProps.default ?? rawProps.options[0] }
				} else {
					return { string: rawProps.default ?? '' }
				}
			}
		}
	},
	methods: {
		closeModal() {
			this.$emit('closeModal');
		},
		handleOptionClick(option) {
			this.$emit('changeOption', option);
		}
	}
}
</script>

<style scoped>
.option {
	@apply after:block after:bg-zt-red after:absolute after:w-1 after:h-10 after:top-1/2 after:left-0
	after:-translate-y-1/2 after:rounded after:opacity-0 after:transition-opacity
	hover:after:opacity-100 hover:bg-[#313E50];
}
.selected {
	@apply after:block after:bg-zt-red after:absolute after:w-1 after:h-10 after:top-1/2 after:left-0
	after:-translate-y-1/2 after:rounded after:transition-opacity
	after:opacity-100 bg-[#313E50];
}
</style>